import React, { Component } from "react";

import {
  CBadge,
  CCard,
  CCardBody,
  CCardHeader,
  CCardFooter,
  CCol,
  CLink,
  CRow
} from "@coreui/react";
import {
  RiAttachmentLine,
  RiCheckboxCircleLine,
  RiClapperboardLine,
  RiCloseCircleLine,
  RiEarthLine,
  RiErrorWarningLine,
  RiFile3Line,
  RiFileList2Line,
  RiGameLine,
  RiImageEditFill,
  RiImageLine,
  RiMap2Fill,
  RiMusic2Fill,
  RiRocket2Fill,
  RiSlideshowLine,
  RiTeamLine,
  RiBook3Line,
  RiBookOpenLine
} from "react-icons/ri";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../../actions/baseActions";
import ImgNoData from "../../../assets/imgs/graduation.svg";
import URL from "../../../config/api";
import axios from "../../../config/axios";
import { baseDate } from "../../../utils/date";
import { getTodoElements, databaseToFlowTrail } from "../../../utils/trail";
import DashboardADRItem from "../../DashboardADRItem";
import DashboardContentItem from "../../DashboardContentItem";
import DashboardListItem from "../../DashboardListItem";
import DashboardTrailItem from "../../DashboardTrailItem";
import Loading from "../../Loading";
import SwitchButton from "../../SwitchButton";

class LegacyStudentDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dashboard: {
        cards: {},
        schedule: null,
        today: null,
        classrooms: [],
        rooms: [],
        trailActivities: []
      },
      primaryColor: null,
      secondaryColor: null,
      grayColor: null,
      isConstruir: false,
      isFormandoGroup: false,
      raw: {},
      listActivitiesAlreadyFinished: {},
      isLoading: true
    };
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  componentDidMount() {
    axios
      .get(`${URL.api}general/dashboard/user`, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          const classrooms = resp.data.data.classrooms.map(room => {
            const activities = resp.data.data.activities.filter(
              activity => activity?.room_id === room.id
            );

            return {
              ...room,
              activities_new: activities.filter(
                activity => activity.activity_percentage >= 100
              ).length,
              activities_pending: activities.filter(
                activity =>
                  activity.activity_percentage < 100 &&
                  new Date(activity.activity_end) >= new Date()
              ).length,
              activities_late: activities.filter(
                activity =>
                  activity.activity_percentage < 100 &&
                  new Date(activity.activity_end) < new Date()
              ).length
            };
          });

          const rawTrailActivities =
            resp.data.data.trails?.reduce((acc, trail) => {
              const trailActivities = getTodoElements(
                databaseToFlowTrail(
                  trail.trail.trail_activities,
                  trail.trail.trail_edges
                )
              ).map(item => ({
                ...item.data.activity,
                room: trail.room,
                user: trail.user,
                trail_allocation_id: trail.id,
                trail_id: trail.trail.id,
                trail_name: trail.trail.name,
                activity_start: item.data.start
                  ? `${item.data.start}`
                  : `${baseDate(new Date())}`,
                activity_end: item.data.end ? `${item.data.end}` : undefined
              }));

              return [...acc, ...trailActivities];
            }, []) || [];

          this.setState(
            {
              raw: resp.data.data,
              rawTrailActivities,
              dashboard: {
                trailActivities: rawTrailActivities,
                schedule: this.group(
                  rawTrailActivities,
                  resp.data.data.activities
                ),
                rooms: resp.data.data.rooms,
                classrooms
              }
            },
            () => {
              this.getEvaluationsEnabled();
            }
          );
        },
        error => {
          // eslint-disable-next-line no-console
          console.log("Não foi possível se comunicar com a plataforma!");
        }
      );

    const id = this.props.general.active_roles.group_id;
    console.log("ID do grupo:", id);
    axios
      .get(`${URL.api}access/group/singleView/${id}`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(respmodule => {
        this.setState(() => ({
          primaryColor: respmodule?.data?.data?.group?.primary,
          secondaryColor: respmodule?.data?.data?.group?.secondary,
          grayColor: respmodule?.data?.data?.group?.primary_grey
        }));
      });

    if (id === 45 || id === 92) {
      this.setState({ isConstruir: true });
    }

    if (id === 80) {
      this.setState({ isFormandoGroup: true });
    }
  }

  getEvaluationsEnabled() {
    const list = this.state.raw.activities.map(
      activity => activity.items[0]?.json?.list_id
    );
    const obj = {
      list_id: list,
      room_id: this.state.raw?.activities[0]?.room_id,
      user_id: this.props.user.user.id
    };
    axios
      .post(`${URL.api}evaluation/application/checkEvaluationListADR`, obj, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        const res = resp.data;
        if (!Array.isArray(res) && !(res.length === 0)) {
          this.setState({ listActivitiesAlreadyFinished: res });
        }
      })
      .finally(() => {
        this.setState({ isLoading: false });
      });
  }

  getBorder(item) {
    if (item.activity_percentage) return "light";
    if (Date.parse(item.activity_end) < Date.now()) return "danger";
    return "primary";
  }

  group(trailActivities, activities) {
    let months = [
      "Jan",
      "Fev",
      "Mar",
      "Abr",
      "Mai",
      "Jun",
      "Jul",
      "Ago",
      "Set",
      "Out",
      "Nov",
      "Dez"
    ];
    let days = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"];

    let myArray = [...trailActivities, ...activities];
    // let myArray = [...activities];

    myArray.sort((a, b) => {
      let c = new Date(a.activity_start ? a.activity_start : a.created_at);
      let d = new Date(b.activity_start ? b.activity_start : b.created_at);
      return d - c;
    });

    let groups = myArray.reduce((r, o) => {
      if (o.activity_start) {
        o = { ...o, activity: true };
      } else {
        o = { ...o, activity: false };
      }

      const dt = new Date(o.activity_start ? o.activity_start : o.created_at);

      let m = `${days[dt.getDay()]}/${`00${dt.getDate()}`.slice(-2)}/${
        months[dt.getMonth()]
      }/${dt.getFullYear()}`;
      r[m] ? r[m].data.push(o) : (r[m] = { group: m, data: [o] });
      return r;
    }, {});

    let result = Object.keys(groups).map(k => groups[k]);

    return result;
  }

  friendlyDate(date) {
    const dt = new Date(date);

    return `${`00${dt.getDate()}`.slice(-2)}/${`00${dt.getMonth() + 1}`.slice(
      -2
    )} ${`00${dt.getHours()}`.slice(-2)}:${`00${dt.getMinutes()}`.slice(-2)}`;
  }

  render() {
    const { schedule, rooms, classrooms } = this.state.dashboard;
    const root = document.documentElement;

    root?.style.setProperty(
      "--primary-group-change",
      this.state.primaryColor != null ? this.state.primaryColor : ""
    );
    root?.style.setProperty(
      "--secondary-group-change",
      this.state.secondaryColor != null ? this.state.secondaryColor : ""
    );
    root?.style.setProperty(
      "--primary-grey-group-change",
      this.state.grayColor != null ? this.state.grayColor : ""
    );

    return (
      <div className="container w-100">
        <CRow className=" mb-3">
          <CCol xs="12" lg="9" xxl="8">
            <h2 className="font-weight-bold text-title mb-3">
              Minhas atividades
            </h2>
            <div className="d-flex flex-wrap mb-3">
              <SwitchButton
                text="Todas"
                icon={<RiFileList2Line />}
                className="mr-3 mb-2"
                onClick={() =>
                  this.setState(state => ({
                    dashboard: {
                      ...state.dashboard,
                      schedule: this.group(
                        state.rawTrailActivities,
                        state.raw.activities
                      )
                    }
                  }))
                }
              />
              <SwitchButton
                text="A fazer"
                icon={<RiErrorWarningLine />}
                className="mb-2 mr-3"
                onClick={() =>
                  this.setState(state => ({
                    dashboard: {
                      ...state.dashboard,
                      schedule: this.group(
                        state.rawTrailActivities,
                        state.raw.activities.filter(
                          activity =>
                            activity.activity_percentage < 100 &&
                            new Date(activity.activity_end) >= new Date()
                        )
                      )
                    }
                  }))
                }
              />
              <SwitchButton
                text="Não realizadas"
                icon={<RiCloseCircleLine />}
                className="mb-2 mr-3"
                onClick={() =>
                  this.setState(state => ({
                    dashboard: {
                      ...state.dashboard,
                      schedule: this.group(
                        [],
                        state.raw.activities.filter(
                          activity =>
                            activity.activity_percentage < 100 &&
                            new Date(activity.activity_end) < new Date()
                        )
                      )
                    }
                  }))
                }
              />
              <SwitchButton
                text="Concluídas"
                icon={<RiCheckboxCircleLine />}
                className="mb-2"
                onClick={() =>
                  this.setState(state => ({
                    dashboard: {
                      ...state.dashboard,
                      schedule: this.group(
                        [],
                        state.raw.activities.filter(
                          activity => activity.activity_percentage >= 100
                        )
                      )
                    }
                  }))
                }
              />
            </div>
            {!this.state.isLoading && schedule ? (
              schedule.length > 0 ? (
                schedule.map((day, index) => (
                  <div key={index}>
                    <h5 className="text-title font-weight-semibold">
                      {day.group.split("/")[0]},{" "}
                      {`${day.group.split("/")[1]} ${day.group.split("/")[2]}${
                        parseInt(day.group.split("/")[3]) ===
                        new Date().getFullYear()
                          ? ""
                          : ` ${day.group.split("/")[3]}`
                      }`}
                    </h5>
                    <div className="my-3">
                      <div className="mb-4">
                        {day.data.map(item =>
                          (this.state.isConstruir ||
                            this.state.isFormandoGroup) &&
                          item.type_id === 6 ? (
                            <DashboardADRItem
                              item={item}
                              className="mb-3"
                              key={item.trail_allocation_id}
                              tokenUser={this.props.user.token}
                              allocationId={item.allocation_id}
                              evaluationIdJson={item?.items[0]?.json?.id}
                              listId={item.items[0].obj_id}
                              listActivitiesAlreadyFinished={
                                this.state.listActivitiesAlreadyFinished
                              }
                            />
                          ) : item.trail_allocation_id ? (
                            <DashboardTrailItem
                              item={item}
                              className="mb-3"
                              key={item.trail_allocation_id}
                            />
                          ) : (
                            <DashboardListItem
                              item={item}
                              className="mb-3"
                              key={item.allocation_id}
                            />
                          )
                        )}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="justify-content-center align-items-center d-flex flex-column my-5">
                  <img
                    src={ImgNoData}
                    style={{ height: "240px", marginBottom: "2rem" }}
                    alt=""
                  />
                  <p
                    style={{ fontSize: "1.5rem" }}
                    className="mb-2 font-weight-bold text-center"
                  >
                    Você ainda não tem nenhuma atividade
                  </p>
                  <span className="text-muted text-center">
                    Acesse os recursos da plataforma através dos menus laterais
                  </span>
                </div>
              )
            ) : (
              <div className="p-4">
                <Loading />
              </div>
            )}
          </CCol>
          <CCol xs="12" lg="3" xxl="4">
            <div className="w-100">
              {classrooms.length > 0 && (
                <>
                  <h2 className="font-weight-bold text-title mb-3">
                    Minhas Turmas
                  </h2>
                  <CRow>
                    {classrooms.map(classroom => (
                      <CCol xxl="6" key={classroom.id}>
                        <CCard>
                          <CCardHeader className="bg-lightblue text-title d-flex flex-column py-2">
                            <CLink
                              to={`/classroom/${classroom.id}`}
                              className="text-title mt-1"
                            >
                              <h5 className="mb-1 text-ellipsis font-weight-semibold">
                                {classroom.name}
                              </h5>
                            </CLink>
                            <div className="small mb-1">
                              {classroom.school_name}
                            </div>
                          </CCardHeader>
                          <CCardBody className="pt-2 pb-1 ">
                            <CBadge
                              color="success"
                              className="mw-100 px-2 py-1 font-weight-normal rounded-pill mr-2 mb-2 text-wrap"
                            >
                              Atv. feitas: {classroom.activities_new}
                            </CBadge>
                            <CBadge
                              color="warning"
                              className="mw-100 px-2 py-1 font-weight-normal rounded-pill mr-2 mb-2 text-wrap"
                            >
                              Atv. pendentes: {classroom.activities_pending}
                            </CBadge>
                            <CBadge
                              color="danger"
                              className="mw-100 px-2 py-1 font-weight-normal rounded-pill mr-2 mb-2 text-wrap"
                            >
                              Atv. atrasadas: {classroom.activities_late}
                            </CBadge>
                          </CCardBody>
                          <CCardFooter className="d-flex text-title py-2">
                            <span className="mr-3" style={{ flex: 1 }}>
                              <RiTeamLine className="mr-2" />
                              {classroom.num_users}
                            </span>
                            <CLink
                              className="mr-3 text-title"
                              to={`/classroom/${classroom.id}/activities`}
                            >
                              <RiFileList2Line />
                            </CLink>
                            <CLink
                              to={`/classroom/${classroom.id}/docs`}
                              className="text-title"
                            >
                              <RiAttachmentLine />
                            </CLink>
                          </CCardFooter>
                        </CCard>
                      </CCol>
                    ))}
                  </CRow>
                </>
              )}
              {rooms.length > 0 && (
                <>
                  <h2 className="font-weight-bold text-title mb-3">
                    Minhas Comunidades
                  </h2>
                  <CRow>
                    {rooms.map(room => (
                      <CCol xxl="6" key={room.id}>
                        <CCard>
                          <CCardHeader className="bg-lightblue text-title d-flex flex-column py-2">
                            <CLink
                              to={`/room/${room.id}`}
                              className="text-title my-1"
                            >
                              <h5 className="mb-0 text-ellipsis font-weight-semibold">
                                {room.name}
                              </h5>
                            </CLink>
                          </CCardHeader>
                          <CCardFooter className="d-flex text-title border-0 py-2">
                            <span className="mr-3" style={{ flex: 1 }}>
                              <RiTeamLine className="mr-2" />
                              {room.num_users}
                            </span>
                            <CLink
                              to={`/room/${room.id}/docs`}
                              className="text-title"
                            >
                              <RiAttachmentLine />
                            </CLink>
                          </CCardFooter>
                        </CCard>
                      </CCol>
                    ))}
                  </CRow>
                </>
              )}
              {this.props.user.user_modules?.find(module => module.id === 2) ? (
                <>
                  <h2 className="font-weight-bold text-title mb-3">Recursos</h2>
                  <CRow>
                    <CCol xs="12" xxl="6" className="text-ellipsis mb-2">
                      <DashboardContentItem
                        name="Meus Documentos"
                        to="docs/me"
                        color="#E36767"
                        icon={<RiAttachmentLine />}
                      />
                    </CCol>
                    <CCol xs="12" xxl="6" className="text-ellipsis mb-2">
                      <DashboardContentItem
                        name="Aulas"
                        to="content/list/1"
                        color="#988FE9"
                        icon={<RiSlideshowLine />}
                      />
                    </CCol>
                    <CCol xs="12" xxl="6" className="text-ellipsis mb-2">
                      <DashboardContentItem
                        name="Jogos"
                        to="content/list/2"
                        color="#EFC261"
                        icon={<RiGameLine />}
                      />
                    </CCol>
                    <CCol xs="12" xxl="6" className="text-ellipsis mb-2">
                      <DashboardContentItem
                        name="Simuladores"
                        to="content/list/6"
                        color="#00BE91"
                        icon={<RiRocket2Fill />}
                      />
                    </CCol>
                    <CCol xs="12" xxl="6" className="text-ellipsis mb-2">
                      <DashboardContentItem
                        name="Imagens"
                        to="content/list/10"
                        color="#72A3BE"
                        icon={<RiImageLine />}
                      />
                    </CCol>
                    <CCol xs="12" xxl="6" className="text-ellipsis mb-2">
                      <DashboardContentItem
                        name="Vídeos"
                        to="content/list/3"
                        color="#00BE91"
                        icon={<RiClapperboardLine />}
                      />
                    </CCol>
                    <CCol xs="12" xxl="6" className="text-ellipsis mb-2">
                      <DashboardContentItem
                        name="Áudios"
                        to="content/list/11"
                        color="#86C3D7"
                        icon={<RiMusic2Fill />}
                      />
                    </CCol>
                    <CCol xs="12" xxl="6" className="text-ellipsis mb-2">
                      <DashboardContentItem
                        name="Livros"
                        to="content/list/9"
                        color="#E97D7D"
                        icon={<RiBook3Line />}
                      />
                    </CCol>
                    <CCol xs="12" xxl="6" className="text-ellipsis mb-2">
                      <DashboardContentItem
                        name="Simuladores 3D"
                        to="content/list/7"
                        color="#C5BA5D"
                        icon={<RiEarthLine />}
                      />
                    </CCol>
                    <CCol xs="12" xxl="6" className="text-ellipsis mb-2">
                      <DashboardContentItem
                        name="Modelos 3D"
                        to="content/list/8"
                        color="#80A1A3"
                        icon={<RiFile3Line />}
                      />
                    </CCol>
                    <CCol xs="12" xxl="6" className="text-ellipsis mb-2">
                      <DashboardContentItem
                        name="Animações"
                        to="content/list/4"
                        color="#A79890"
                        icon={<RiImageEditFill />}
                      />
                    </CCol>
                    <CCol xs="12" xxl="6" className="text-ellipsis mb-2">
                      <DashboardContentItem
                        name="Mapas"
                        to="content/list/5"
                        color="#C99678"
                        icon={<RiMap2Fill />}
                      />
                    </CCol>
                  </CRow>
                </>
              ) : this.props.user.user_modules?.find(
                  module => module.id === 11
                ) ? (
                <>
                  <h2 className="font-weight-bold text-title mb-3"></h2>
                  <CRow>
                    <CCol xs="12" className="text-ellipsis mb-2">
                      <DashboardContentItem
                        name="Biblioteca"
                        to="library"
                        color="#6f42c1"
                        icon={<RiBookOpenLine />}
                      />
                    </CCol>
                    <CCol xs="12" className="text-ellipsis mb-2">
                      <DashboardContentItem
                        name="Meus Documentos"
                        to="docs/me"
                        color="#E36767"
                        icon={<RiAttachmentLine />}
                      />
                    </CCol>
                  </CRow>
                </>
              ) : this.props.user.user_modules?.find(
                  module => module.id === 3
                ) ? (
                <>
                  <h2 className="font-weight-bold text-title mb-3"></h2>
                  <CRow>
                    <CCol xs="12" className="text-ellipsis mb-2">
                      <DashboardContentItem
                        name="Meus Documentos"
                        to="docs/me"
                        color="#E36767"
                        icon={<RiAttachmentLine />}
                      />
                    </CCol>
                  </CRow>
                </>
              ) : null}
            </div>
          </CCol>
        </CRow>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile,
  form: state.form
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LegacyStudentDashboard);
